export const browserNameAndVersion = (delimiter = ''): string => {
  const agent = navigator.userAgent.toLowerCase();
  const regStr_ie = /msie [\d.]+/gi;
  const regStr_ff = /firefox\/[\d.]+/gi;
  const regStr_chrome = /chrome\/[\d.]+/gi;
  const regStr_saf = /safari\/[\d.]+/gi;
  const regStr_opr = /opr\/[\d.]+/gi;
  const regStr_edg = /edg\/[\d.]+/gi;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let browserNV: any;

  // ie
  if (agent.indexOf('msie') > 0) {
    browserNV = agent.match(regStr_ie);
  }

  // firefox
  if (agent.indexOf('firefox') > 0) {
    browserNV = agent.match(regStr_ff);
  }

  // chrome
  // @ts-expect-error TS2339: Property 'chrome' does not exist on type 'Window & typeof globalThis'.
  if (agent.indexOf('chrome') > 0 && Boolean(globalThis.chrome)) {
    if (agent.indexOf('opr/') > 0) {
      // opera
      browserNV = agent.match(regStr_opr);
    } else if (agent.indexOf('edg/') > 0) {
      // edge
      browserNV = agent.match(regStr_edg);
    } else {
      browserNV = agent.match(regStr_chrome);
    }
  }

  // safari
  if (agent.indexOf('safari') > 0 && agent.indexOf('chrome') < 0) {
    browserNV = agent.match(regStr_saf);
  }

  browserNV = browserNV.toString();

  // other
  if ('' == browserNV) {
    browserNV = 'Unknown';
  }

  if (browserNV.indexOf('firefox') != -1 || agent.indexOf('chrome') != -1) {
    browserNV = browserNV.replace('/', delimiter);
  }

  if (browserNV.indexOf('msie') != -1) {
    browserNV = browserNV.replace('msie', 'ie').replace(/\s/g, delimiter);
  }

  return browserNV;
};

export enum BrowserNameEnum {
  Arc = 'Arc',
  Brave = 'Brave',
  Chrome = 'Chrome',
  Firefox = 'Firefox',
  MicrosoftEdge = 'Microsoft Edge',
  Opera = 'Opera',
  Safari = 'Safari',
  Other = 'Other'
}

let userAgent: Navigator['userAgent'] | undefined;
const getUserAgent = () => {
  if (userAgent == null) {
    if (typeof navigator === 'undefined') {
      // During static generation we should default to a chrome on windows, it does not make sense for us to use SSR as that would be extra cost with no benefit
      return 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/136.0.0.0 Safari/537.36';
    } else {
      userAgent = navigator.userAgent;
    }
  }

  return userAgent;
};

const computeBrowserName = () => {
  const userAgent = getUserAgent();
  const { brave } =
    (globalThis.navigator as Navigator & {
      brave?: { isBrave: () => Promise<boolean> };
    }) ?? {};
  const agent = userAgent.toLowerCase();

  const isChrome = /chrome|crios/.test(agent) && !/edge|edg\/|opr\//.test(agent);
  const isBrave = isChrome && brave?.isBrave;

  if (isBrave) return BrowserNameEnum.Brave;
  // @ts-expect-error TS(7017): Element implicitly has an 'any' type because type ... Remove this comment to see the full error message
  if (isChrome && Boolean(globalThis.chrome)) return BrowserNameEnum.Chrome;
  if (agent.includes('edg/')) return BrowserNameEnum.MicrosoftEdge;
  // @ts-expect-error TS(7017): Element implicitly has an 'any' type because type ... Remove this comment to see the full error message
  if (agent.includes('opr/') && Boolean(globalThis.opr)) return BrowserNameEnum.Opera;
  if (agent.includes('firefox')) return BrowserNameEnum.Firefox;
  if (getComputedStyle(document.documentElement).getPropertyValue('--arc-palette-title')) return BrowserNameEnum.Arc;
  if (agent.includes('safari')) return BrowserNameEnum.Safari;

  return BrowserNameEnum.Other;
};
let browserName: BrowserNameEnum | undefined;
export const getBrowserName = () => {
  if (browserName === undefined) {
    browserName = computeBrowserName();
  }
  return browserName;
};

export const isOnMicrosoftEdgeBrowser = (): boolean => {
  if (typeof navigator === 'undefined') return false;

  const agent = getUserAgent().toLowerCase();

  if (agent.includes('edg/')) return true;
  return false;
};

export const isWindows = (): boolean => {
  const userAgent = getUserAgent();
  return userAgent.includes('Windows') || navigator.platform.startsWith('Win');
};

export const isIOS = () => /iPad|iPhone|iPod/.test(getUserAgent());
export const isAndroid = () => /Android/.test(getUserAgent());
export const isMobile = () => isIOS() || isAndroid();

export const isFirefox = () => getBrowserName() === BrowserNameEnum.Firefox;
export const isSafari = () => getBrowserName() === BrowserNameEnum.Safari;
export const isChromeBased = () =>
  [
    //
    BrowserNameEnum.Arc,
    BrowserNameEnum.Brave,
    BrowserNameEnum.Chrome,
    BrowserNameEnum.Opera,
    BrowserNameEnum.MicrosoftEdge
  ].includes(getBrowserName());
